import OfferingApi from "../../api/Offerings";
import { offeringTypes } from "../types/offering.types";
import BasicNotification from "../../shared/components/Notifications/BasicNotification";

export const getOfferts = (cb) => async (dispatch) => {
  dispatch({ type: offeringTypes.HANDLE_OFFERT_REQUEST });
  try {
    const { body } = await OfferingApi.getOfferts();
    if (cb) {
      cb(body);
    }
    dispatch({ type: offeringTypes.HANDLE_OFFERT_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: offeringTypes.HANDLE_OFFERT_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener ofertas');
  }
};

export const getOffertByQuotation = (id, cb) => async (dispatch) => {
  dispatch({ type: offeringTypes.HANDLE_OFFERT_REQUEST });
  try {
    const { body } = await OfferingApi.getOffertByQuotation(id);
    if (cb) {
      cb(body);
    }
    dispatch({ type: offeringTypes.HANDLE_OFFERT_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: offeringTypes.HANDLE_OFFERT_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener ofertas');
  }
};
export const getMyOfferts = (id, cb) => async (dispatch) => {
  dispatch({ type: offeringTypes.GET_MY_OFFERTS_REQUEST });
  try {
    const { body } = await OfferingApi.getMyOfferts(id);
    if (cb) {
      cb(body);
    }
    dispatch({ type: offeringTypes.GET_MY_OFFERTS_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: offeringTypes.GET_MY_OFFERTS_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener ofertas hechas');
  }
};

export const createOffert = (data, cb) => async (dispatch) => {
  dispatch({ type: offeringTypes.POST_OFFERT_REQUEST });
  try {
    const { body, status } = await OfferingApi.createOffert(data);
    if (cb) {
      cb(status, body);
    }
    dispatch({ type: offeringTypes.POST_OFFERT_SUCCESS, payload: { body } });
    BasicNotification.success('Ofertas creadas con éxito.');
  } catch (error) {
    dispatch({ type: offeringTypes.POST_OFFERT_FAILED, payload: { error } });
    error && BasicNotification.error('Error al registrar una o más ofertas');
  }
};

export const updateOffert = (id, data, cb) => async (dispatch) => {
  dispatch({ type: offeringTypes.PUT_OFFERT_REQUEST });
  try {
    const { body } = await OfferingApi.updateOffert(id, data);
    if (cb) {
      cb(body);
    }
    dispatch({ type: offeringTypes.PUT_OFFERT_SUCCESS, payload: { body } });
    BasicNotification.success('Ofeta actualizada con éxito');
  } catch (error) {
    error && dispatch({ type: offeringTypes.PUT_OFFERT_FAILED, payload: { error } });
    BasicNotification.error('Error al intentar actualizar oferta');
  }
};

export const removeOffertById = (id, cb) => async (dispatch) => {
  dispatch({ type: offeringTypes.HANDLE_OFFERT_REQUEST });
  try {
    const { body } = await OfferingApi.removeOffertById(id);
    if (cb) {
      cb(body);
    }
    dispatch({ type: offeringTypes.HANDLE_OFFERT_SUCCESS, payload: { body } });
    BasicNotification.success('Oferta eliminada con éxito.');
  } catch (error) {
    error && dispatch({ type: offeringTypes.HANDLE_OFFERT_FAILED, payload: { error } });
    BasicNotification.error('Error al intentar eliminar oferta');
  }
};

export const resetOfferts = () => async (dispatch) => {
  dispatch({ type: offeringTypes.RESET_OFFERTS });
};

export const resetMyOfferts = () => async (dispatch) => {
  dispatch({ type: offeringTypes.RESET_MY_OFFERTS });
};

